import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import { InvoiceCountsEntity } from "../../entities/InvoiceEntity";

/**
 * Get Invoice Counts Use Case
 * Retrieves counts for all invoice categories for dashboard cards
 */
export class GetInvoiceCountsUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(params?: {
    date_from?: string;
    date_to?: string;
  }): Promise<InvoiceCountsEntity> {
    return await this.repository.fetchInvoiceCounts(params);
  }
}

